<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8749 13.5409H9.3083C8.19997 13.5409 7.29163 12.6075 7.29163 11.4575C7.29163 11.1159 7.57496 10.8325 7.91663 10.8325C8.25829 10.8325 8.54163 11.1159 8.54163 11.4575C8.54163 11.9159 8.8833 12.2909 9.3083 12.2909H10.8749C11.1999 12.2909 11.4583 11.9992 11.4583 11.6409C11.4583 11.1909 11.3333 11.1242 11.05 11.0242L8.54163 10.1492C8.00829 9.96587 7.29163 9.57422 7.29163 8.34922C7.29163 7.30755 8.11664 6.44922 9.12497 6.44922H10.6916C11.7999 6.44922 12.7083 7.38255 12.7083 8.53255C12.7083 8.87422 12.425 9.15755 12.0833 9.15755C11.7416 9.15755 11.4583 8.87422 11.4583 8.53255C11.4583 8.07422 11.1166 7.69922 10.6916 7.69922H9.12497C8.79997 7.69922 8.54163 7.99088 8.54163 8.34922C8.54163 8.79922 8.66662 8.86588 8.94995 8.96588L11.4583 9.84088C11.9916 10.0242 12.7083 10.4159 12.7083 11.6409C12.7083 12.6909 11.8833 13.5409 10.8749 13.5409Z"
            fill="currentColor" />
        <path
            d="M10 14.375C9.65833 14.375 9.375 14.0917 9.375 13.75V6.25C9.375 5.90833 9.65833 5.625 10 5.625C10.3417 5.625 10.625 5.90833 10.625 6.25V13.75C10.625 14.0917 10.3417 14.375 10 14.375Z"
            fill="currentColor" />
        <path
            d="M9.99996 18.9596C5.05829 18.9596 1.04163 14.943 1.04163 10.0013C1.04163 5.05964 5.05829 1.04297 9.99996 1.04297C10.3416 1.04297 10.625 1.3263 10.625 1.66797C10.625 2.00964 10.3416 2.29297 9.99996 2.29297C5.74996 2.29297 2.29163 5.7513 2.29163 10.0013C2.29163 14.2513 5.74996 17.7096 9.99996 17.7096C14.25 17.7096 17.7083 14.2513 17.7083 10.0013C17.7083 9.65964 17.9916 9.3763 18.3333 9.3763C18.675 9.3763 18.9583 9.65964 18.9583 10.0013C18.9583 14.943 14.9416 18.9596 9.99996 18.9596Z"
            fill="currentColor" />
        <path
            d="M17.5 6.45833H14.1666C13.825 6.45833 13.5416 6.175 13.5416 5.83333V2.5C13.5416 2.15833 13.825 1.875 14.1666 1.875C14.5083 1.875 14.7916 2.15833 14.7916 2.5V5.20833H17.5C17.8416 5.20833 18.125 5.49167 18.125 5.83333C18.125 6.175 17.8416 6.45833 17.5 6.45833Z"
            fill="currentColor" />
        <path
            d="M14.1666 6.45755C14.0083 6.45755 13.85 6.39922 13.725 6.27422C13.4833 6.03255 13.4833 5.63255 13.725 5.39089L17.8916 1.22422C18.1333 0.982552 18.5333 0.982552 18.775 1.22422C19.0166 1.46589 19.0166 1.86588 18.775 2.10755L14.6083 6.27422C14.4833 6.39922 14.325 6.45755 14.1666 6.45755Z"
            fill="currentColor" />
    </svg>


</template>

<script>
export default {
    name: 'DashboardIcon',

    data() {
        return {

        }
    },
    computed: {
    },
};
</script>